"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @deprecated
 * Please use https://github.com/streamich/react-use/blob/master/docs/useClickAway.md
 */
class ClickOutside extends React.PureComponent {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "node", /*#__PURE__*/React.createRef());
    (0, _defineProperty2.default)(this, "handleClickOutside", ev => {
      const {
        active,
        onClickOutside
      } = this.props;
      if (active && this.node && ev.target instanceof Node && this.node.current != null && !this.node.current.contains(ev.target)) {
        onClickOutside(ev);
      }
    });
  }
  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside, true);
    document.addEventListener("focus", this.handleClickOutside, true); // needed to catch clicks into textfields, see https://gitlab.skypicker.com/frontend/nitrolib/issues/39
  }
  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside, true);
    document.removeEventListener("focus", this.handleClickOutside, true);
  }
  render() {
    const {
      className,
      children
    } = this.props;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: className,
      ref: this.node,
      children: children
    });
  }
}
exports.default = ClickOutside;
(0, _defineProperty2.default)(ClickOutside, "defaultProps", {
  active: true
});